import * as React from 'react';
import ToggleButtons from 'src/components/common/ToggleButtons';
import { IButtons } from 'src/components/common/ToggleButtons/ToggleButtons';
import './FiltersBarMobile.scss';
import DateRangeSeparated from 'src/components/common/DateRangeSeparated';
import Dropdown from 'src/components/common/Dropdown';
import { IOption } from 'src/components/common/Dropdown/Dropdown';
import Input from 'src/components/common/Input';
import Button from 'src/components/common/Button';
import BadgeButton from 'src/components/common/BadgeButton';
import SlideMenu from 'src/components/common/SlideMenu';
import i18n from 'src/translation/i18n';

export interface IFilterBarProps {
  typeOfItemOptions: IButtons[];
  selectedTypeOfItem: string;
  onSelectedTypeOfItemChange: (value: any) => void;
  searchByOptions: IOption[];
  filterByOptions?: IOption[];
  selectedFilterBy?: string;
  onSelectedFilterByChange?: (value: any) => void;
  selectedSearchBy: string;
  onSelectedSearchByChange: (value: any) => void;
  dates?: any;
  setDates?: (date: any) => void;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  onSearchButtonClick: () => void;
  itemsLength?: number;
  sortBy: string[];
  setSortBy: (values: string[]) => void;
  handleSortItemsStatus?: (value: string) => void;
  returnCartAction?: (status: boolean) => void;
}

const FiltersBarMobile: React.FC<IFilterBarProps> = ({
  typeOfItemOptions,
  selectedTypeOfItem,
  onSelectedTypeOfItemChange,
  searchByOptions,
  selectedSearchBy,
  onSelectedSearchByChange,
  dates,
  setDates,
  filterByOptions,
  selectedFilterBy,
  onSelectedFilterByChange,
  searchQuery,
  onSearchQueryChange,
  onSearchButtonClick,
  itemsLength,
  sortBy,
  setSortBy,
  handleSortItemsStatus,
  returnCartAction
}) => {
  const [showFilterSlideMenu, setShowFilterSlideMenu] = React.useState(false);
  const [showSearchSlideMenu, setShowSearchSlideMenu] = React.useState(false);
  const [sortEligible, setSortEligible] = React.useState<string[]>(sortBy);
  const [filterDates, setFilterDates] = React.useState(dates);
  const [statusFilter, setStatusFilter] = React.useState(selectedFilterBy);

  const handleClickSorting = (e: any, value: string) => {
    e.preventDefault();

    if (setDates) {
      handleSortItemsEligible(value);
    }

    if (handleSortItemsStatus) {
      handleSortItemsStatus(value);
    }
  };

  const handleSortItemsEligible = (option: string) => {
    const sortFiltered = sortEligible.map(s => s.split(',')[0]);
    const indexFiltered = sortFiltered.indexOf(option.split(',')[0]);
    const indexSort = sortEligible.indexOf(option);

    if (indexSort === -1 && indexFiltered === -1) {
      // INSERT
      setSortEligible([...sortEligible, option]);
    } else if (indexSort !== -1 && indexFiltered !== -1) {
      // REMOVE
      setSortEligible(sortEligible.filter((el, i) => i !== indexSort));
    } else if (indexSort === -1 && indexFiltered !== -1) {
      // SUBSTITUTE
      const newSortEligible = sortEligible.filter(
        (el, i) => i !== indexFiltered
      );
      setSortEligible([...newSortEligible, option]);
    }
  };

  const handleSaveFilters = () => {
    if (onSelectedFilterByChange) {
      onSelectedFilterByChange(statusFilter);
    }

    setSortBy(sortEligible);
    if (setDates && filterDates && filterDates.start && filterDates.end) {
      setDates(filterDates);
    }
  };

  const sortOptions = [
    {
      value: 'partNumber,desc',
      label: `${i18n.t('myReturns.mobile.partNumberAZ')}`
    },
    {
      value: 'partNumber,asc',
      label: `${i18n.t('myReturns.mobile.partNumberZA')}`
    },
    {
      value: 'invoiceNumber,asc',
      label: `${i18n.t('myReturns.mobile.invoiceAsc')}`
    },
    {
      value: 'invoiceNumber,desc',
      label: `${i18n.t('myReturns.mobile.invoiceDsc')}`
    },
    {
      value: 'invoiceDate,asc',
      label: `${i18n.t('myReturns.mobile.invoiceDateON')}`
    },
    {
      value: 'invoiceDate,desc',
      label: `${i18n.t('myReturns.mobile.invoiceDateNO')}`
    }
  ];

  return (
    <>
      <div className="rp-my-returns-mobile__filters-bar">
        {!filterByOptions && (
          <BadgeButton
            action={returnCartAction}
            disabled={itemsLength === 0}
            badgeValue={itemsLength}
            buttonClass="primary-button"
          >
            <i className="rpds-shopping-cart" />
            <span>
              {(i18n.t('myReturns.returnsCart') as string).toUpperCase()}
            </span>
          </BadgeButton>
        )}
        <ToggleButtons
          value={selectedTypeOfItem}
          onValueChange={value => onSelectedTypeOfItemChange(value)}
          buttons={typeOfItemOptions}
        />
        <div className="rp-filters-search-button-container">
          <div
            className="rp-filter-sorting-button"
            onClick={() => setShowFilterSlideMenu(!showFilterSlideMenu)}
          >
            <i className="rpds-sort" />
            <span>{i18n.t('common.filtersAndSorting')}</span>
          </div>
          <div
            className="rp-search-button"
            onClick={() => setShowSearchSlideMenu(!showSearchSlideMenu)}
          >
            <i className="rpds-search" />
            <span>{i18n.t('common.search')}</span>
          </div>
        </div>
        <SlideMenu
          mounted={showFilterSlideMenu}
          goBackTitle={i18n.t('common.backToResults')}
          level={100}
          handleCloseMenu={() => setShowFilterSlideMenu(false)}
        >
          <div className="rp-slide-menu-container">
            <div>
              <span className="rp-filterby-title">
                {i18n.t('categories.filterByDate')}:
              </span>
              {setDates && (
                <DateRangeSeparated
                  dates={filterDates}
                  onDatesSelected={setFilterDates}
                />
              )}
              {filterByOptions && (
                <Dropdown
                  options={filterByOptions}
                  onSelected={value => setStatusFilter(value)} // TODO: Do proper function
                  activeOption={statusFilter} // TODO: Send proper value
                />
              )}
              <span className="rp-filterby-title">
                {i18n.t('common.sortBy')}:
              </span>
              <div className="rp-sort-options-container">
                {sortOptions.map(({ value, label }) => {
                  return (
                    <a
                      className={`rp-sort-option ${
                        sortEligible.indexOf(value) !== -1
                          ? 'rp-sort-option--selected'
                          : ''
                      }`}
                      key={value}
                      onClick={e => handleClickSorting(e, value)}
                      href="#"
                    >
                      {label}
                    </a>
                  );
                })}
              </div>
            </div>
            <Button
              label={(i18n.t('common.saveFilters') as string).toUpperCase()}
              action={handleSaveFilters}
              buttonClass="primary-button"
              height="56px"
            />
          </div>
        </SlideMenu>
        <SlideMenu
          mounted={showSearchSlideMenu}
          goBackTitle={i18n.t('common.backToResults')}
          level={100}
          handleCloseMenu={() => setShowSearchSlideMenu(false)}
        >
          <div className="rp-slide-menu-container">
            <div>
              <span className="rp-filterby-title">
                {i18n.t('common.searchBy')}:
              </span>
              <div>
                <Dropdown
                  options={searchByOptions}
                  onSelected={value => onSelectedSearchByChange(value)}
                  activeOption={selectedSearchBy}
                />
                <Input
                  value={searchQuery}
                  onChange={value => onSearchQueryChange(value)}
                  placeholder={i18n.t('myreturns.searchHerePlaceHolder')}
                />
              </div>
            </div>
            <Button
              label={i18n.t('common.search')}
              action={() => {
                onSearchButtonClick();
              }}
              buttonClass="primary-button"
              height="56px"
            />
          </div>
        </SlideMenu>
      </div>
    </>
  );
};

export default FiltersBarMobile;
